import {NotificationDto} from "@/api/dto/notification";
import {devtools} from "zustand/middleware";
import {create} from "zustand";


export type NotificationState = {
    popoverOpen: boolean;
    setPopoverOpen: (val: boolean) => void;
    notifications: NotificationDto[];
    setNotifications: (val: NotificationDto[]) => void;
    totalNotifications: number;
    setTotalNotifications: (val: number) => void;
    totalUnreadNotifications: number;
    setTotalUnreadNotifications: (val: number) => void;
    isApiLoading: boolean;
    setApiLoading: (val: boolean) => void
}

export const useNotificationStore = create<NotificationState>()(
  devtools(
    (set) => ({
      popoverOpen: false,
      setPopoverOpen: (val: boolean) => set({popoverOpen: val}),
      notifications: [],
      setNotifications: (val: NotificationDto[]) => set({notifications: val}),
      totalNotifications: 0,
      setTotalNotifications: (val: number) => set({totalNotifications: val}),
      totalUnreadNotifications: 0,
      setTotalUnreadNotifications: (val: number) => set({totalUnreadNotifications: val}),
      isApiLoading: false,
      setApiLoading: val => set({isApiLoading: val})
    }),
    {name: 'notificationStore', enabled: ['local', 'dev', 'qa'].includes(process.env.REACT_APP_ENV || 'prod')},
  ),
);
